import React from "react";

const ABN = () => {
    return (
        <div className="mb-6">
            <p className="text-justify font-medium text-base text-black  leading-relaxed">
                Refraction is the process used to determine the eye's refractive error and assess the need for corrective lenses. 
                Please note that refraction is typically considered a non-covered service by Medicare and most insurance companies. 
                As a result, the cost of the refraction is the patient's responsibility.
                <br />
                At Southern Eye Group, our fee for a refraction is $50. Additionally, our Contact Lens Exam fees range from $75 to $110. 
                These charges are payable at the time of your visit, along with any copayment, deductible, or outstanding balance for the medical portion of your examination
                <br />
                By signing below, you acknowledge that you have read and understand that refraction is a non-covered service and accept full financial responsibility for the cost. 
                <br />
            </p>
        </div>
    );
};

export default ABN;
